import { fetchJson, upload } from '../base'
import { hashPassword } from '@/utils/crypto'
import { getCurrentUserType, withoutAdminSchoolId } from '@/utils/systemRequestScope'

const userBaseUrl = '/drs-serv/sys/user'

export function getUserList(params) {
  //食堂用户调用另一个接口
  const path = getCurrentUserType() === '02'? `${userBaseUrl}/queryByUserType`: `${userBaseUrl}/query`
  return fetchJson(path, withoutAdminSchoolId(params))
}

export function addUser(data) {
  return fetchJson(`${userBaseUrl}/add`, Object.assign({}, data, {
    password: hashPassword(data.password)
  }))
}

export function updateUser(data) {
  return fetchJson(`${userBaseUrl}/update`, withoutAdminSchoolId(data))
}

export function updateUserAvatar(data) {
  return fetchJson(`${userBaseUrl}/avatar/modify`, withoutAdminSchoolId(data))
}

export function modifyUserPassword(data) {
  return fetchJson(`${userBaseUrl}/password/modify`, withoutAdminSchoolId(Object.assign({}, data, {
    passwordOld: hashPassword(data.passwordOld),
    passwordNew: hashPassword(data.passwordNew)
  })))
}

export function deleteUser(userId) {
  return fetchJson(`${userBaseUrl}/delete`, { userId })
}

export function batchDeleteUser(userIds) {
  return fetchJson(`${userBaseUrl}/deleteBatch`, { userIds })
}

export function exportUser(params) {
  return fetchJson(`${userBaseUrl}/export`, withoutAdminSchoolId(params))
}

export function importUser(data) {
  const forceImport = data && data.get ? data.get('forceImport') : ''
  const query = forceImport !== '' ? `?forceImport=${encodeURIComponent(forceImport)}` : ''
  return upload(`${userBaseUrl}/import${query}`, data)
}

export function updateUserStatus(userId, status) {
  return fetchJson(`${userBaseUrl}/status`, { userId, status })
}

export function getUserDetail(userId) {
  return fetchJson(`${userBaseUrl}/detail`, { userId })
}

export function checkSchoolUserAccount(account) {
  return fetchJson(`${userBaseUrl}/schoolUser`, { account })
}

export function resetUserPassword(userId, password) {
  return fetchJson(`${userBaseUrl}/password/reset`, withoutAdminSchoolId({
    userId,
    password: hashPassword(password)
  }))
}

export function getUserSchoolList(params) {
  const path = getCurrentUserType() === '00'
    ? `${userBaseUrl}/school/queryByAdmin`
    : `${userBaseUrl}/school/query`
  return fetchJson(path, withoutAdminSchoolId(params))
}



// WEBPACK FOOTER //
// ./src/api/user/user.api.js